module.exports = __webpack_public_path__ + "static/sortable-socials-bb1544fe1b0985748b829254f303d32c.mp4";